export const FLEX_DIRECTION_CLASSES = {
    row: 'flex-row',
    'row-reverse': 'flex-row-reverse',
    column: 'flex-col',
    'column-reverse': 'flex-col-reverse',
};
export const applyFlexDirection = (flexDirection) => [
    ...(flexDirection ? [FLEX_DIRECTION_CLASSES[flexDirection]] : []),
];
